import React, { Dispatch, SetStateAction, SyntheticEvent } from 'react';

import { Button } from 'components/Button';
import { Input } from 'components/Input';
import { useNavigate } from 'react-router-dom';

type ConfirmationInputFormProps = {
  verificationCode: string;
  verificationError: boolean;
  setVerificationCode: Dispatch<SetStateAction<string>>
  handleSubmit: (event: SyntheticEvent) => Promise<void>
  handleResendCode: () => Promise<void>
}

export const ConfirmationInputForm = ({
  verificationCode,
  setVerificationCode,
  verificationError,
  handleSubmit,
  handleResendCode,
}: ConfirmationInputFormProps) => {
  const navigate = useNavigate();

  return (
    <div className='login-page-container'>
      <img 
        width="300"
        height="150"
        src={require('assets/vlted_logo_transparent_black.png')}
        className="App-logo"
        alt="logo"
      />
      <form id="verification-code-form" onSubmit={handleSubmit}>
        <label>
          <p className="text">
            Verification Code:
          </p>
          <Input
            id='verification-code-input'
            accessibilityLabel='verification-code-input'
            value={verificationCode}
            handleOnChange={setVerificationCode}
            error={verificationError ? 'Something went wrong!' : undefined}
            icon='comment'
          />
        </label>
      </form>
      <Button
        accessibilityLabel='sign-in-button'
        type='primary'
        text='Confirm verification code'
        formName='verification-code-form'
        disabled={!verificationCode}
      />
      <div className='sign-in-secondary-buttons-container'>
        <Button
          accessibilityLabel='cancel-button'
          type='tertiary'
          text='Cancel'
          handleOnClick={() => navigate(0)}
        />
        <Button
          accessibilityLabel='resend-button'
          type='tertiary'
          text='Resend'
          handleOnClick={() => handleResendCode()}
        />
      </div>
    </div>
  );
};
